import { useState } from "react";
import { customFile } from "features/customFile";
import { ImageField, ImageInput, useNotify, useInput } from "react-admin";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Stack from "@mui/material/Stack";
import { Typography } from "@mui/material";

const SingleImageInput = ({
  index,
  source,
  name,
  label,
  isDisable,
  isRequired,
  SubCategoryId,
  setIsDisable,
  onUploadSuccess,
  isMulty,
  onRemove,
  isValidate,
  helperText = null,
  resource,
}) => {
  const notify = useNotify();
  const validImageFormat = ["image/jpeg", "image/png", "application/pdf"];
  const { field } = useInput({ source: `${source}_${index}`, type: "file" });

  const handleChange = async file => {
    if (!file) return;

    if (isValidate && !validImageFormat.includes(file.type)) {
      // ".jpeg, .jpg, .png, .pdf, .docx, .doc, .xlsx"
      notify("Невалиден формат! Позволени формати: jpeg, png, pdf", { type: "error" });
      field.onChange(null);
      return;
    }

    setIsDisable(true);
    try {
      const response = await customFile(
        resource,
        { File: file, SubCategoryId, name: "DocumentName" },
        "POST",
        null,
        true,
      );

      onUploadSuccess(index, response.data);
    } catch (err) {
      notify(err.message || "Възникна грешка! Вашата снимка не е прикачена.", { type: "error" });
      field.onChange(null);
    } finally {
      setIsDisable(false);
    }
  };

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        spacing={1}
      >
        <ImageInput
          source={`${source}_${index}`}
          name={`${name}_${index}`}
          readOnly={isDisable}
          validate={value => {
            if (isValidate) {
              if (!value && isRequired) return "Прикачете снимка във формат: jpeg, png, pdf ";
              const file = value?.rawFile;
              const validTypes = ["image/jpeg", "image/png", "application/pdf"];
              if (file && !validTypes.includes(file?.type)) {
                return "Позволени формати за прикачване на снимка: jpeg, png, pdf";
              }
            }
          }}
          label={label}
          value={field.value}
          onChange={e => {
            if (e) handleChange(e);
          }}
        >
          <ImageField
            source="src"
            title="title"
          />
        </ImageInput>
        {isMulty && index !== 0 && <DeleteOutlineIcon onClick={() => onRemove(index)} />}
      </Stack>
      <Typography
        color={"red"}
        mb={3}
      >
        Позволени формати: {helperText || ".jpeg, .jpg, .png, .pdf, .docx, .doc, .xlsx "}
      </Typography>
    </>
  );
};

const CustomImageInput = ({
  isDisable,
  setIsDisable,
  label,
  SubCategoryId,
  setDataId,
  isRequired,
  source,
  name,
  isMulty,
  isValidate,
  helperText,
  resource,
}) => {
  const [inputs, setInputs] = useState([0]);
  const [uploadedIds, setUploadedIds] = useState([]);

  const addInput = () => {
    setInputs(prev => [...prev, prev.length]);
  };

  const handleUploadSuccess = (index, newId) => {
    if (isMulty) {
      const newIds = [...uploadedIds];
      newIds[index] = newId;
      setUploadedIds(newIds);
      setDataId(newIds);
    } else {
      setUploadedIds([newId]);
      setDataId(newId);
    }
  };
  const handleRemove = index => {
    setInputs(prev => prev.filter(i => i !== index));
    if (isMulty) {
      const newIds = [...uploadedIds];
      newIds[index] = null;
      const filtered = newIds.filter(Boolean);
      setUploadedIds(filtered);
      setDataId(filtered);
    }
  };
  return (
    <>
      {inputs.map(inputIndex => (
        <SingleImageInput
          key={inputIndex}
          index={inputIndex}
          source={source}
          name={name}
          label={label}
          helperText={helperText}
          isDisable={isDisable}
          setIsDisable={setIsDisable}
          isRequired={isRequired}
          SubCategoryId={SubCategoryId}
          onUploadSuccess={handleUploadSuccess}
          onRemove={handleRemove}
          isMulty={isMulty}
          isValidate={isValidate}
          resource={resource}
        />
      ))}

      {isMulty && <AddCircleOutlineIcon onClick={addInput} />}
    </>
  );
};

export default CustomImageInput;
